import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductDocument.ListDealerGroupDocuments.IRequest;
type Response = Api.Core.ProductDocument.ListDealerGroupDocuments.IResponse;
type Headers = Api.Core.ProductDocument.ListDealerGroupDocuments.IHeaders;
const url = '/api/ProductManagement/ProductDealerDocument/DealerGroupDocuments';
export default async function productDocumentListDealerGroupDocumentsApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
